import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Body2 } from "@activecollab/components";
import PropTypes from "prop-types";
import { getFormattedCreditCardNumber } from "~/store/selectors/selector.billingPaymentMethod";

const StripePaymentMethodInfo = ({ paymentMethod, isExpiredCreditCard }) => {
  const { t } = useTranslation();
  const cardNumber = useSelector((state) => getFormattedCreditCardNumber(state));

  return (
    <div className="tw-flex tw-flex-col md:tw-grid md:tw-grid-cols-[200px_auto] md:tw-grid-rows-2 tw-gap-2">
      <Body2
        color="primary"
        weight="bold"
      >
        {t("Payment Type")}
      </Body2>
      <Body2
        color="tertiary"
        data-testid="cardType"
      >
        {paymentMethod.cardType}
      </Body2>
      <Body2
        color="primary"
        weight="bold"
      >
        {t("Card Number")}
      </Body2>
      <Body2
        color="tertiary"
        data-testid="cardNumber"
      >
        {cardNumber}
      </Body2>
      <Body2
        color={isExpiredCreditCard ? "alert" : "primary"}
        weight="bold"
      >
        {t("Expiration Date")}
      </Body2>
      <Body2
        color={isExpiredCreditCard ? "alert" : "tertiary"}
        data-testid="expirationDate"
      >
        {`${paymentMethod.expirationMonth}/${paymentMethod.expirationYear}`}
      </Body2>
    </div>
  );
};

StripePaymentMethodInfo.propTypes = {
  paymentMethod: PropTypes.object.isRequired,
  isExpiredCreditCard: PropTypes.bool,
};

export default StripePaymentMethodInfo;
